import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { class: "icon-wrapper" }
const _hoisted_5 = { class: "body" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "footer" }

import { Modal, Button, Icon } from "@/components/ui";


export default /*@__PURE__*/_defineComponent({
  __name: 'LinkedInConfirmationModal',
  props: {
    show: { type: Boolean },
    contactsCount: {},
    loading: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const handleClose = () => {
  if (!props.loading) {
    emit("close");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Modal), {
      show: __props.show,
      size: "sm",
      "close-on-backdrop": !__props.loading,
      "close-on-escape": !__props.loading,
      "show-close-button": !__props.loading,
      "blur-backdrop": false,
      "backdrop-opacity": 0,
      onClose: handleClose
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(Icon), {
                icon: "fluent-mdl2:people-add",
                class: "icon"
              })
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header-text" }, [
              _createElementVNode("h2", { class: "title" }, "Confirm enrichment")
            ], -1))
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_unref(Button), {
            variant: "secondary",
            size: "md",
            disabled: __props.loading,
            onClick: handleClose
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" No ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_unref(Button), {
            variant: "primary",
            size: "md",
            loading: __props.loading,
            disabled: __props.loading,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm')))
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode(" Yes, Enrich ", -1)
            ]))]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, [
            _cache[2] || (_cache[2] = _createTextVNode(" You are about to enrich and import ", -1)),
            _createElementVNode("strong", null, _toDisplayString(__props.contactsCount) + " contacts", 1),
            _cache[3] || (_cache[3] = _createTextVNode(" from your LinkedIn Sales Navigator search. This action will add them to your contacts list. ", -1))
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "close-on-backdrop", "close-on-escape", "show-close-button"])
  ]))
}
}

})